export default "__VITE_ASSET__4bbcf40e__"